import { fieldsList } from "../../../data/data.js";

function ExportDonorModal({
  closeModal,
  setView,
  selectedFields,
  handleSelectAll,
  handleCheckboxChange,
  filters,
  downloadExcel,
  downloading,
}) {
  return (
    <div
      className="modal fade"
      id="exportDonorExcelModal"
      tabIndex="-1"
      aria-labelledby="exportDonorExcelModal"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exportDonorExcelModal">
              Export Details
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                closeModal();
                setView("excel");
              }}
            ></button>
          </div>

          <div className="modal-body">
            <h6 className="mb-2">Select Fields to Export</h6>

            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="selectAll"
                checked={selectedFields.length === fieldsList.length}
                onChange={handleSelectAll}
              />
              <label className="form-check-label fw-bold" htmlFor="selectAll">
                Select All
              </label>
            </div>

            <hr />

            <div className="d-flex flex-row flex-wrap">
              {fieldsList.map((field, index) => (
                <div className="form-check d-flex" key={index}>
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    id={`field-${index}`}
                    checked={selectedFields.includes(field)}
                    onChange={() => handleCheckboxChange(field)}
                  />

                  <label
                    className="form-check-label"
                    htmlFor={`field-${index}`}
                  >
                    {field?.split("_")?.join(" ")}
                  </label>
                </div>
              ))}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger btn-round"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-success btn-round"
                onClick={() => {
                  if (
                    filters.search ||
                    filters.level ||
                    filters.agency ||
                    filters.payment_mode ||
                    filters.status
                  ) {
                    downloadExcel("donor");
                  } else {
                    const confirmFullDownload = window.confirm(
                      "No filters applied. Do you want to download the full sheet?",
                    );
                    if (confirmFullDownload) {
                      downloadExcel("donor");
                    }
                  }
                }}
                disabled={downloading}
              >
                Export Donor
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExportDonorModal;
